import React from 'react';
import ScreenshotsAndExtraFiles from './ScreenshotsAndExtraFiles/ScreenshotsAndExtraFiles';
import { getTests } from '../../Utils/TestResultsMethods';
import PassedAndFailed from './PassedAndFailed/PassedAndFailed';
import { isEmpty } from '../../Utils/helpers';
import { AIFalsePositiveIcon } from './AIFalsePositiveIcon/AIFalsePositiveIcon';
import './TestResultsAccordionHeader.css';

export function TestResultsAccordionHeader({
  name = '',
  status = 'PASSED',
  screenshots = [],
  extraFiles = [],
  type = '',
  onScreenshotsClick,
  extraActions = [],
  openScreenshotModal,
  closeScreenshotModal,
  children,
  showAIFalsePositive = false,
  aiAnalysisDescription = '',
}) {
  let decodedName;
  try {
    decodedName = decodeURIComponent(name);
  } catch (e) {
    decodedName = name;
  }

  return (
    <div
      className={[
        status,
        'inline-flex-container',
        'test-result-header-container',
      ].join(' ')}
    >
      <span
        className='test-results-header-text'
        name='test-results-header-text'
        lang='ar'
      >
        {decodedName}
      </span>
      {!isEmpty(extraActions) && (
        <div className='inline-flex-container extra-actions-container'>
          {extraActions}
        </div>
      )}
      <AIFalsePositiveIcon
        isVisible={showAIFalsePositive}
        aiAnalysisDescription={aiAnalysisDescription}
      />

      {(!isEmpty(screenshots) || !isEmpty(extraFiles)) && (
        <ScreenshotsAndExtraFiles
          screenshots={screenshots}
          extraFiles={extraFiles}
          onClickScreenshots={openScreenshotModal}
        />
      )}
      {!isEmpty(children) && (
        <PassedAndFailed
          title={type}
          passed={getTests('PASSED', children)}
          failed={getTests('FAILED', children)}
        />
      )}
    </div>
  );
}
